import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  CardMedia,
  Paper,
} from '@mui/material';
import styled from '@emotion/styled';

// Customised MUI Components
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  padding: theme.spacing(1),
  opacity: 1,
  borderRadius: '10psx',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontFamily: 'Neue Montreal Medium',
}));

const ProjectsCard = (props) => {
  // Destructuring data from Props
  const { title, description, github, image, preview } = props.project;

  return (
    <Card
      sx={{
        height: '720px',
        width: '340px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* ----- Project Image ----  */}
      <Item style={{ flex: 1 }}>
        <CardMedia
          component='img'
          alt={title}
          image={image}
          style={{
            width: '100%',
            height: '450px',
            objectFit: 'fill',
          }}
        />
      </Item>

      <CardContent style={{ flex: 1, maxHeight: '200px', overflow: 'auto' }}>
        {/* ---- Project Title ------ */}
        <Typography
          variant='h6'
          gutterBottom
          component='div'
          sx={{
            height: 'fit-content',
            fontFamily: 'Neue Montreal Medium',
          }}
        >
          {title}
        </Typography>
        {/* ----- Project Description -------- */}
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{
            height: 'fit-content',
            py: 2,
            px: 1,
            fontFamily: 'Neue Montreal Medium',
          }}
        >
          {description}
        </Typography>
      </CardContent>
      {/* ------ External Links -------- */}
      <CardActions style={{ marginTop: 'auto', justifyContent: 'flex-end' }}>
        <StyledButton size='medium' href={github} target='_blank'>
          GitHub
        </StyledButton>
        <StyledButton size='medium' href={preview} target='_blank'>
          Preview
        </StyledButton>
      </CardActions>
    </Card>
  );
};

export default ProjectsCard;
